<agpr-take-over-panel
    [id]="id"
    [header]="headerTitle"
    [showFooter]="true"
    styleClass="social"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="closeDialog(true)"
    (closeTakeover)="agentChanged()"
    [width]="showEstimate ? 100 : 40"
    [validateBeforeClose]="showCanLeaveDialog()"
    [footerContext]="'Social.intelligence.themeManagement.agent' | localize"
    [formGroup]="archiveForm"
>
    <div
        class="agpr-archiveSearch-container"
        [agprLoading]="loading"
    >
        <div
            class="lhp"
            [ngClass]="{
                'lhp--hasEstimate': showEstimate,
                'lhp--haveResetMessage': showResetMessage
            }"
        >
            <agpr-scroll-panel
                #scrollpanel
                class="lhpScroll"
            >
                <!-- Archive search settings -->
                <agpr-message
                    *ngIf="archiveMode === archiveSearchMode.create || archiveMode === archiveSearchMode.edit"
                    [severity]="messageSeverities.info"
                    [style]="agprComponentStyle.social"
                >
                    {{ 'Social.archiveSearch.message' | localize }}
                </agpr-message>
                <div
                    class="agpr-archiveSearch-archiveSearchType"
                    role="radiogroup"
                    [attr.aria-label]="'Social.archiveSearch.searchOptions' | localize"
                    formGroupName="header"
                >
                    <agpr-radio
                        formControlName="newSearch"
                        [id]="id + '_radio_newOption'"
                        [label]="archiveMode === archiveSearchMode.saveAs ? 'Social.archiveSearch.saveAsNew' : 'Social.archiveSearch.newSearch'"
                        [hiddenLabel]="archiveMode === archiveSearchMode.saveAs ? 'Social.archiveSearch.saveAsNew' : 'Social.archiveSearch.newSearch'"
                        [agprStyle]="agprComponentStyle.social"
                        [value]="true"
                    ></agpr-radio>
                    <agpr-radio
                        formControlName="existingSearch"
                        [id]="id + '_radio_fromExistingOption'"
                        [label]="archiveMode === archiveSearchMode.saveAs ? 'Social.archiveSearch.saveAsExisting' : 'Social.archiveSearch.copyFromExisting'"
                        [hiddenLabel]="archiveMode === archiveSearchMode.saveAs ? 'Social.archiveSearch.saveAsExisting' : 'Social.archiveSearch.copyFromExisting'"
                        [agprStyle]="agprComponentStyle.social"
                        [value]="true"
                    ></agpr-radio>
                    <div
                        *ngIf="existingSearch.value"
                        class="agpr-archiveSearch-socialTopicAutocomplete"
                    >
                        <agpr-autocomplete
                            formControlName="existingAgent"
                            [id]="id + '_autocomplete'"
                            class="agpr-multi-field-chips-autocomplete"
                            [dropdown]="true"
                            placeholder="Social.archiveSearch.fromExisting.autocompletePlaceholder"
                            ariaLabel="Social.archiveSearch.fromExisting.autocompletePlaceholder"
                            ariaDescribedBy="noTopic_error"
                            [suggestions]="agentService?.all$"
                            [forceSelection]="true"
                            [labelField]="'name'"
                            [style]="agprComponentStyle.social"
                            [clearOnBlur]="false"
                            panelStyleClass="agpr-archiveSearch-socialTopicAutocomplete-panel"
                        ></agpr-autocomplete>
                        <agpr-form-message
                            *ngIf="header.errors?.['noTopic'] && existingAgent.touched"
                            id="noTopic_error"
                        >
                            {{ (archiveMode === archiveSearchMode.saveAs ?
                                "Social.agentWidget.error.noTopic.save" :
                                "Social.agentWidget.error.noTopic.search") | localize }}
                        </agpr-form-message>
                    </div>
                </div>

                <!-- Date -->
                <div
                    class="agpr-archiveSearch-dateRange"
                    *ngIf="(newSearch.value || existingAgent.value) && archiveMode !== archiveSearchMode.saveAs"
                >
                    <div  class="lhpRow">
                        <label class="lhp-subHeading">
                            {{ "Social.archiveSearch.dateRange" | localize }}
                        </label>
                    </div>
                    <agpr-date-query-popup
                        formControlName="date"
                        id="archiveSearchDateQuery"
                        class="agpr-themePostFeed-toolbar-dateFilter"
                        [header]="'Monitoring.dateQueryDialog.header'"
                        [options]="dateOptions"
                        [toolTipLabel]="'Common.dateQueryInput.dateFilter'"
                        [searchRange]="searchRange"
                        [style]="agprComponentStyle.social"
                    ></agpr-date-query-popup>
                </div>

                <div *ngIf="!name.disabled && newSearch.value">
                    <agpr-inplace
                        formControlName="name"
                        [id]="id + '_inplace'"
                        class="lhp-inplace"
                        [maxLength]="255"
                        [style]="agprComponentStyle.social"
                        tooltipPosition="left"
                        ariaDescribedBy="name_errors"
                        [ariaInvalid]="name.errors?.['required'] || name.errors?.['duplicateName']"
                    ></agpr-inplace>
                    <ul id="name_errors">
                        <li *ngIf="name.errors?.['duplicateName']">
                            <agpr-form-message>
                                {{ "Social.agentWidget.error.nameExists" | localize }}
                            </agpr-form-message>
                        </li>
                        <li *ngIf="name.errors?.['required']">
                            <agpr-form-message>
                                {{ "Social.agentWidget.error.nameMinLength" | localize }}
                            </agpr-form-message>
                        </li>
                    </ul>
                </div>
                <div
                    *ngIf="newSearch.value || existingAgent.value"
                    formGroupName="general"
                >
                    <ng-container
                        formGroupName="section"
                    >
                        <div class="agpr-archiveSearch-fieldWrapper">
                            <agpr-network-multi-select
                                formControlName="networks"
                                [id]="id + '_network_multiSelect'"
                                heading="Social.agentWidget.availableNetworks"
                                [allowedNetworks]="allowedNetworks"
                                ariaDescribedBy="noNetwork_error"
                                [unavailableNetworks]="notAllowedNetworks"
                            ></agpr-network-multi-select>
                            <agpr-form-message
                                *ngIf="networks.errors?.['required']"
                                id="noNetwork_error"
                            >
                                {{ "Social.agentWidget.error.noNetwork" | localize }}
                            </agpr-form-message>
                        </div>

                        <agpr-include-exclude-chips
                            formControlName="keywords"
                            [id]="id + '_keywords_includeExclude'"
                            class="lhp-include"
                            caretTooltip="Social.agentWidget.keywords.expandToolTip"
                            headerLabel="Social.agentWidget.keywords"
                            placeholder="Social.agentWidget.keywords.placeholder"
                            [chipValidations]="[minLengthValidation, mustNotBeOperator]"
                            [style]="agprComponentStyle.social"
                            [splitOnPattern]="splitOnPattern"
                            tooltip="Social.agentWidget.keywords.tooltip"
                            ariaDescribedBy="keyword_errors"
                        ></agpr-include-exclude-chips>
                        <ul
                            id="keyword_errors"
                            class="keywordError"
                        >
                            <li *ngIf="general.errors?.['noHandleAndKeyword'] && (keywords.touched || handles.touched)">
                                <agpr-form-message>
                                    {{ "Social.agentWidget.error.keywordOrHandle" | localize }}
                                </agpr-form-message>
                            </li>
                            <li *ngIf="section.errors?.['invalidCharKeyword']">
                                <agpr-form-message>
                                    {{ "Social.agentWidget.error.keyword.invalidCharacter" | localize }}
                                </agpr-form-message>
                            </li>
                            <li *ngIf="keywords.errors?.['hashtagSymbol']">
                                <agpr-form-message>
                                    {{ "Social.agentWidget.error.keyword.hashtag" | localize }}
                                </agpr-form-message>
                            </li>
                            <li *ngIf="keywords.errors?.['maxKeyword']">
                                <agpr-form-message>
                                    {{ "Social.agentWidget.error.keywordMaximum" | localize }}
                                </agpr-form-message>
                            </li>
                        </ul>
                    </ng-container>

                    <div>
                        <div class="lhpRow">
                            <agpr-button
                                class="lhp-caret"
                                [style]="buttonTypes.icon"
                                [icon]="
                                    handleExpanded
                                        ? 'fa-solid fa-angle-down'
                                        : 'fa-solid fa-angle-right'
                                "
                                tooltipPosition="right"
                                [expanded]="handleExpanded"
                                (click)="toggleExpanded()"
                            >
                                <label class="lhp-subHeading--bold">
                                    {{ "Social.agentWidget.handleChannel" | localize }}
                                </label>
                            </agpr-button>
                            <span
                                class="fa-regular fa-circle-info agpr-archiveSearch-infoIcon"
                                role="img"
                                [agprTooltip]="(archiveMode === archiveSearchMode.create || archiveMode === archiveSearchMode.edit ?
                                    'Social.agentWidget.handleChannel.isArchiveSearch.tooltip' : 'Social.agentWidget.handleChannel.tooltip') | localize"
                                tooltipPosition="top"
                            ></span>
                        </div>
                        <div
                            *ngIf="handleExpanded"
                            class="handle-container"
                            formArrayName="handles"
                        >
                            @for (network of handles.controls; track network) {
                                @switch (network.value.type) {
                                    @case (networkType.twitter) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-x-twitter"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_Twitter'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.twitter"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[twitterValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="twitter_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="twitter_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    @case (networkType.facebook) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-facebook"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_Facebook'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.facebook"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[facebookValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="facebook_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="facebook_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    @case (networkType.instagram) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-instagram"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_Instagram'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.instagram"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[instaValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="instagram_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="instagram_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    @case (networkType.youtube) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-youtube"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_Youtube'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.youtube"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[youtubeValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="youtube_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="youtube_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    @case (networkType.reddit) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-reddit"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_Reddit'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.reddit"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[redditValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="reddit_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="reddit_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    @case (networkType.subReddit) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-reddit"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_subReddit'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.subReddit"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[subRedditValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="sub_reddit_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="sub_reddit_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    @case (networkType.tiktok) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-tiktok"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_TikTok'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.tiktok"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[tiktokValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="tiktok_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="tiktok_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    @case (networkType.linkedin) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-linkedin"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_LinkedIn'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.linkedin"
                                                    [disabled]="agentForm.disabled"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[linkedinValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="linkedin_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="linkedin_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                    @case (networkType.bluesky) {
                                        <div>
                                            <div
                                                class="handleRow"
                                                [formGroup]="network"
                                            >
                                                <span class="fa-brands fa-bluesky"></span>
                                                <agpr-text-input-chips
                                                    formControlName="handleValues"
                                                    class="handle"
                                                    [id]="id + '_handle_Bluesky'"
                                                    placeholder="Social.agentWidget.handlePlacehoder.bluesky"
                                                    [disabled]="agentForm.disabled"
                                                    [style]="agprComponentStyle.social"
                                                    [chipValidations]="[blueskyValidation, minLengthValidation]"
                                                    [trimQuotes]="true"
                                                    [splitOnPattern]="splitOnPattern"
                                                    ariaDescribedBy="bluesky_handle_errors"
                                                ></agpr-text-input-chips>
                                            </div>
                                            <ul
                                                id="bluesky_handle_errors"
                                                class="handlesError"
                                            >
                                                @if (network.errors?.['duplicateHandle']) {
                                                    <li>
                                                        <agpr-form-message>
                                                            {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                        </agpr-form-message>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                }
                            }
                        </div>
                    </div>
                </div>

                <ng-container
                    *ngIf="archiveMode === archiveSearchMode.saveAs && (newSearch.value || existingAgent.value)"
                >
                    <div class="agpr-archiveSearch-divide"></div>

                    <div class="lhpStatus">
                        <div class="agpr-archiveSearch-heading">
                            <label class="lhp-subHeading">
                                {{ "Social.agentWidget.pendingStatus" | localize }}
                            </label>
                            <span
                                role="img"
                                class="fa-regular fa-circle-info agpr-archiveSearch-infoIcon"
                                agprTooltip="Social.agentWidget.pendingStatus.tooltip"
                                tooltipPosition="top"
                            ></span>
                        </div>
                        <agpr-social-topic-status-switch
                            [id]="id"
                            formControlName="status"
                        ></agpr-social-topic-status-switch>
                    </div>

                    <div class="lhpCol">
                        <label
                            *ngIf="archiveMode === archiveSearchMode.edit; else create"
                            for="createAgentWidget.AddToThemes.dropdown.input"
                            class="lhp-subHeading"
                        >
                            {{ "Social.agentWidget.InTheme" | localize }}
                        </label>
                        <ng-template #create>
                            <label
                                for="createAgentWidget.AddToThemes.dropdown.input"
                                class="lhp-subHeading"
                            >
                                {{ "Social.agentWidget.addToTheme" | localize }}
                            </label>
                        </ng-template>

                        <agpr-dropdown-chips
                            formControlName="themes"
                            [id]="id + '_AddToThemes'"
                            placeholder="Social.agentWidget.addToTheme.placeholder"
                            [optionsFetcher]="themeOptionFetcher"
                            [validationFunction]="validateTheme"
                            (onValidationError)="onThemeError($event)"
                            labelLookupValue="name"
                            labelLookupKey="id"
                            [style]="agprComponentStyle.social"
                            (add)="scrollToBottom()"
                        ></agpr-dropdown-chips>
                    </div>
                </ng-container>
            </agpr-scroll-panel>
            <div class="agpr-archiveSearch-message">
                <agpr-message
                    *ngIf="showResetMessage"
                    [severity]="messageSeverities.info"
                    [style]="agprComponentStyle.social"
                    [noBottomCornerRadius]="true"
                    [centerContent]="true"
                    [closeable]="true"
                >
                    <span>{{ 'Social.archiveSearch.resetFilter1' | localize}}</span>
                    <agpr-button
                        label="Social.archiveSearch.resetFilter2"
                        (click)="resetSearchProperties()"
                        [style]="buttonTypes.link"
                        class="agpr-archiveSearch-resetFilterLink"
                    ></agpr-button>
                </agpr-message>
            </div>
        </div>

        <div
            *ngIf="showEstimate"
            class="rhp"
            [agprloading]="loadingEstimate"
        >
            <agpr-scroll-panel class="rhp-scrollPanel">
                <agpr-message
                    [severity]="messageSeverities.info"
                    [style]="agprComponentStyle.social"
                >
                    {{ "Social.agentWidget.estimateInfo" | localize }}
                </agpr-message>
                <div
                    *ngIf="hasEstimate"
                    class="rhp-row"
                >
                    <div class="rhp-section rhp-estimateCount">
                        <div class="rhp-estimateCount-content">
                            <label class="rhp-estimateCountLabel">{{ "Social.agentWidget.estimateUsage" | localize }}</label>
                            <span class="rhp-estimateCountNumber">{{ estimatedAgentUsageRange }}</span>
                        </div>
                    </div>
                    <div class="rhp-section rhp-estimateProportion">
                        <label class="rhp-estimateProportionLabel">{{ 'Social.agentWidget.estimateUsage.barChartTitle' | localize }}</label>
                        <agpr-chart
                            [chart]="quotaEstimateChart"
                        ></agpr-chart>
                    </div>
                </div>
                <agpr-message
                    *ngIf="!hasEstimate"
                    [severity]="messageSeverities.noContent"
                >
                    {{ 'Social.agentWidget.estimateUsage.noEstimate' | localize }}
                </agpr-message>
                <div class="rhp-heading">
                    <label class="agpr-archiveSearch-postViewLabel">
                        {{ "Social.agentWidget.postPreview" | localize }}
                    </label>
                    <span
                        role="img"
                        class="fa-regular fa-circle-info agpr-archiveSearch-infoIcon"
                        agprTooltip="Social.agentWidget.estimateUsage.postView.info"
                        tooltipPosition="top"
                    ></span>
                </div>
                <div *ngFor="let mention of mentions; index as i">
                    <agpr-social-post-feed-card
                        [mention]="mention"
                        [showImages]="false"
                    ></agpr-social-post-feed-card>
                </div>
                <agpr-message
                    *ngIf="!hasSamplePosts"
                    [severity]="messageSeverities.noContent"
                >
                    {{ (hasEstimate ?
                        'Social.agentWidget.estimateUsage.noSamplePosts.general'
                        : 'Social.agentWidget.estimateUsage.noSamplePosts.twitter'
                    ) | localize }}
                </agpr-message>
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="closeDialog(true)"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            *ngIf="!showEstimate && archiveMode === archiveSearchMode.saveAs"
            [id]="id + '_estimateButton'"
            label="Social.agentWidget.getEstimate"
            [style]="buttonTypes.primaryB"
            (click)="showEstimate = true; getEstimate()"
        ></agpr-button>
        <agpr-button
            *ngIf="archiveMode === archiveSearchMode.create || archiveMode === archiveSearchMode.edit"
            [id]="id + '_archiveSearchButton'"
            label="Social.archiveSearch.button.search"
            [tooltip]="errorTooltip"
            tooltipPosition="left"
            [style]="buttonTypes.primary"
            (click)="search()"
            [disabled]="!archiveForm.valid"
        ></agpr-button>
        <agpr-button
            *ngIf="archiveMode === archiveSearchMode.saveAs"
            [id]="id + '_saveArchiveSearchBtn'"
            label="Social.agentWidget.button.save"
            [disabled]="!archiveForm.valid"
            [tooltip]="errorTooltip"
            tooltipPosition="left"
            [style]="buttonTypes.primary"
            (click)="save()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
